"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeklyScheduleInfoItemsCreator = void 0;
const contexts_1 = require("../../core/contexts");
const helpers_1 = require("../../helpers");
const helpers_2 = require("./helpers");
require("./models");
const ScheduleInfoItemsCreator_1 = require("./ScheduleInfoItemsCreator");
require("./types");
class WeeklyScheduleInfoItemsCreator extends ScheduleInfoItemsCreator_1.ScheduleInfoItemsCreator {
    constructor(labels, texts, model) {
        super(labels, texts, model);
        this.labels = labels;
        this.texts = texts;
        this.model = model;
        this.getRowThirdValueForFormatter = () => {
            return this.getRowThirdValueForFormatterWithExcluded();
        };
        this.getRowFirstValue = () => {
            const value = this.getRowFirstValueForFormatter();
            return this.getScheduleInfoItemValue(value.create, contexts_1.parseTextConfig(this.texts.weeklyScheduleRowFirstSecondFilledLabel, value), contexts_1.parseTextConfig(this.texts.scheduleRowAnyEmptyLabel, {
                rowLabel: this.labels.rowFirst.wordForm.plural,
            }));
        };
        this.getRowSecondValue = () => {
            const isEnabled = this.model.isSecondRowExistingAndEnabled();
            const value = this.getRowSecondValueForFormatter();
            if (!this.labels.rowSecond) {
                return '';
            }
            return this.getScheduleInfoItemValue(value.create, contexts_1.parseTextConfig(this.texts.weeklyScheduleRowFirstSecondFilledLabel, value), contexts_1.parseTextConfig(this.texts.scheduleRowAnyEmptyLabel, {
                rowLabel: this.labels.rowSecond.wordForm.plural,
            }), !isEnabled, contexts_1.parseTextConfig(this.texts.scheduleRowAnyDisabled, {
                rowLabel: `${helpers_1.capitalize(this.labels.rowSecond.wordForm.plural)}`,
            }));
        };
        this.getRowThirdValue = () => {
            const value = this.getRowThirdValueForFormatter();
            if (!this.labels.rowThird) {
                return '';
            }
            return this.getScheduleInfoItemValue(value.create, contexts_1.parseTextConfig(this.texts.weeklyScheduleRowThirdFilledLabel, value), contexts_1.parseTextConfig(this.texts.scheduleRowAnyEmptyLabel, {
                rowLabel: this.labels.rowThird.wordForm.plural,
            }));
        };
        this.getCommonScheduleInfoItems = (rowFirstValue, rowSecondValue, rowThirdValue) => {
            var _a, _b;
            const modelValue = this.model.getValue();
            const isSecondRowEnabled = this.model.isSecondRowExistingAndEnabled();
            const isThirdRowEnabled = this.model.isThirdRowExistingAndEnabled();
            const daysItems = helpers_2.getTextOptionsList(helpers_2.getDaysOfWeekList(), this.texts);
            const items = [
                {
                    label: this.labels.rowFirst.title,
                    value: rowFirstValue,
                    tooltipData: this.getTooltipData(modelValue.rows.first.schedule, daysItems, this.texts.excludedDays),
                },
                isSecondRowEnabled && {
                    label: ((_a = this.labels.rowSecond) === null || _a === void 0 ? void 0 : _a.title) || '',
                    value: rowSecondValue,
                    tooltipData: this.getTooltipData(modelValue.rows.second.schedule, daysItems, this.texts.excludedDays),
                },
                isThirdRowEnabled && {
                    label: ((_b = this.labels.rowThird) === null || _b === void 0 ? void 0 : _b.title) || '',
                    value: rowThirdValue,
                    tooltipData: this.getTooltipData(modelValue.rows.third.schedule, daysItems, this.texts.excludedDays),
                },
            ].filter(Boolean);
            return items;
        };
        this.getScheduleInfoItems = (repositoryName) => {
            const modelValue = this.model.getValue();
            const time = modelValue.fields.time;
            const isThirdRowEnabled = this.model.isThirdRowExistingAndEnabled();
            const scheduleInfoItems = [];
            const commonScheduleInfoItems = this.getCommonScheduleInfoItems(this.getRowFirstValue(), this.getRowSecondValue(), this.getRowThirdValue());
            scheduleInfoItems.push({
                label: this.texts.restorePointTimeLabel,
                value: time,
            });
            scheduleInfoItems.push(...commonScheduleInfoItems);
            if (isThirdRowEnabled) {
                const storageClass = contexts_1.parseTextConfig(this.texts.storageClassLabel, {
                    storageClass: this.texts.storageClass,
                });
                scheduleInfoItems.push({
                    label: this.texts.repositoryLabel,
                    value: `${repositoryName} ${storageClass}`,
                });
            }
            return scheduleInfoItems;
        };
        this.labels = labels;
        this.texts = texts;
        this.model = model;
    }
}
exports.WeeklyScheduleInfoItemsCreator = WeeklyScheduleInfoItemsCreator;
//# sourceMappingURL=WeeklyScheduleInfoItemsCreator.js.map